// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

import less from 'less'
Vue.use(less)
import "./static/css/reset.css"
// Vue.use(Popup);

import { Picker, Popup, Empty, List } from 'vant';
Vue.use(Picker);
Vue.use(Popup);
Vue.use(Empty);
Vue.use(List);
Vue.use(Empty);
// import VueLoading from 'vuejs-loading-plugin'
// // using default options
// Vue.use(VueLoading)
// // overwrite defaults
// Vue.use(VueLoading, {
//   dark: true, // default false
//   text: 'Ladataan', // default 'Loading'
//   loading: true, // default false
//   customLoader: myVueComponent, // replaces the spinner and text with your own
//   background: 'rgb(255,255,255)', // set custom background
//   classes: ['myclass'] // array, object or string
// })

//所有页面和组件加入mixin
import $mixins from './mixins/index.js'
Vue.mixin($mixins)

//一些通用的函数集合
import commomConfig from './static/js/common.js'
Vue.prototype.$common = commomConfig

// axios数据对接
import axiosAjax from './static/js/axios.js'
Vue.prototype.$axios = axiosAjax;

//vuex
import store from './store'
Vue.prototype.$store = store

//辅助监听onLaunched后再执行某函数
Vue.prototype.$onLaunched = new Promise(resolve => {
	Vue.prototype.$isResolve = resolve
})

// 模板-通用头尾
// import mHeader from "./components/header"
// Vue.component("m-header",mHeader)
// import mFooter from "./components/footer"
// Vue.component("m-footer",mFooter)


Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	components: { App },
	template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js